import { defineMessages } from 'react-intl';

export default defineMessages({
  concernedExpertises: {
    id: 'expert_expertise_concerned_expertises.title',
  },
  addExpertise: {
    id: 'expert_expertise_concerned_expertises.add_expertise',
  },
  judiciaryExpertise: {
    id: 'expert_expertise_concerned.judiciary_expertise',
  },
  consultingExpertise: {
    id: 'expert_expertise_concerned.consulting_expertise',
  },
  expertise: {
    id: 'fill_expertise.expertise',
  },
  victim: {
    id: 'fill_expertise.victim',
  },
  medicalPharmaceuticalFees: {
    id: 'fill_expertise.medical_and_pharmaceutical_costs',
  },
  itt: {
    id: 'fill_expertise.itt',
  },
  ipp: {
    id: 'fill_expertise.ipp',
  },
  thirdPartyAppeals: {
    id: 'fill_expertise.use_of_a_third_party',
  },
  pretiumDoloris: {
    id: 'fill_expertise.pretium_doloris',
  },
  aestheticHarmWithoutConsequence: {
    id: 'fill_expertise.aesthetic_harm_without_consequence',
  },
  aestheticDamageWithConsequence: {
    id: 'fill_expertise.aesthetic_damage_with_consequence',
  },
  careerPrejudice: {
    id: 'fill_expertise.career_damage',
  },
  schoolingPrejudice: {
    id: 'fill_expertise.prejudice_to_schooling',
  },
  comment: {
    id: 'fill_expertise.comment',
  },
  victimIncome: {
    id: 'fill_expertise.victim_income',
  },
  back: {
    id: 'back_move_buttons.back',
  },
  expertReportpourcentage: {
    id: 'legal_proceedings.expert_report.percentage',
  },
  causalityLink: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_causality_link',
  },
  isDeathRelatedToClaim: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_is_death_related_to_claim',
  },
  statusTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.status',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  createdByTitle: {
    id: 'expert_expertise.created_by.title',
  },
  annualFixedRevenue: {
    id:
      'legal_proceedings.expert_report.accounting_expertise.fixed_annual_revenue',
  },
  commentAppreciation: {
    id: 'fill_expertise.comment_appreciation',
  },
  damageAmount: {
    id: 'legal_proceedings.expert_report.mechanical_expertise.damage_amount',
  },
  vehicleTitle: {
    id: 'expert_expertise_victim_table.vehicle_title',
  },
  documentStampedTitle: {
    id: 'expert_expertise.doc_stamped.title',
  },
  missionDate: {
    id: 'expertise.table_header_titles.missionDate',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  certificatDescription: {
    id: 'expert_expertise_victim.certificat_description.field',
  },
  clinicalExamination: {
    id: 'expert_expertise_victim.clinical_examination.field',
  },
  injuryDescription: {
    id: 'expert_expertise_victim.injury_description.field',
  },
});
